export default __webpack_public_path__ + "static/media/kyc-man.3dd48fd6.png";